import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  selectedPatient: {},
  ivfIdListData: [],
  attendingDrList: [],
  isDrListLoading: false,
  ivfIdList: [],
  isIvfListLoading: false,
  medicineList: [],
  isMedicineListLoading: false,
  isShowDatabaseBackupModal: false,
  moduleWiseDropdownData: [],
  selectedModuleTab: "",
};
export const getAttendingDrList = createAsyncThunk(
  "get-attending-dr-list",
  (data, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .get("attending-doctor/list")
        .then((res) => {
          if (res?.data?.err === 0) {
            if (res.data?.data?.length > 0) {
              const drList = res.data.data.map((item) => {
                return { ...item, value: item._id, label: item.user_name };
              });
              resolve(drList);
            } else {
              resolve([]);
            }
          } else {
            reject([]);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);
export const getIvfId = createAsyncThunk(
  "ivf-flow/list",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { locationId, patientRegId, moduleId, paramsModule } = props;
      axios
        .get(
          `ivf-flow/list/${locationId}/${patientRegId}/${moduleId}`,
          paramsModule && {
            params: {
              module: paramsModule,
            },
          }
        )
        .then((res) => {
          if (res?.data?.err === 0) {
            if (res.data?.data?.length > 0) {
              const ivfIdList =
                res.data.data.map((item) => {
                  return {
                    ...item,
                    value: item._id,
                    label: item.ivf_id,
                  };
                }) || [];
              const ivfIdListData =
                ivfIdList.filter((item) => {
                  return item.value !== "new";
                }) || [];
              resolve({ ivfIdList, ivfIdListData });
            } else {
              resolve([]);
            }
          } else {
            reject([]);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const getMedicineDetailList = createAsyncThunk(
  "get-medicine-detail-list",
  (props, { dispatch }) => {
    const { payload } = props;
    return new Promise((resolve, reject) => {
      axios
        .post("medicine-detail/list", payload)
        .then((res) => {
          if (res?.data?.err === 0) {
            if (res.data?.data?.length > 0) {
              const medicineList = res.data.data.map((item) => {
                return {
                  ...item,
                  value: item.medicine_name,
                  label: item.medicine_name,
                };
              });
              resolve(medicineList);
            } else {
              resolve([]);
            }
          } else {
            reject([]);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const openDatabaseBackupPopup = createAsyncThunk(
  "database-backup-popup-open",
  () => {
    return new Promise((resolve, reject) => {
      axios
        .get("database/backup-popup/open")
        .then((res) => {
          const resData = res?.data;
          if (resData?.err === 0) {
            if (resData?.data) {
              resolve(resData?.data?.popup_open);
            } else {
              resolve(false);
            }
          } else {
            reject(false);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const cancelDatabaseBackupPopup = createAsyncThunk(
  "database-backup-popup-cancel",
  () => {
    return new Promise((resolve, reject) => {
      axios
        .get("database/backup-popup/cancel")
        .then((res) => {
          const resData = res?.data;
          if (resData?.err === 0) {
            if (resData?.data) {
              resolve(resData?.data);
            } else {
              resolve(false);
            }
          } else {
            reject(false);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const createDatabaseBackup = createAsyncThunk(
  "create-database-backup",
  () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`database/create-backup`)
        .then((res) => {
          if (res?.data?.err === 0) {
            window.open(res.data.data.url, "_blank");
            resolve(res.data.data);
          } else {
            toast.error(res?.data?.msg);
            reject({ message: res?.data?.msg });
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const getModuleWiseAllDropdownList = createAsyncThunk(
  "get-all-dropdown-list-according-module",
  (payload, { dispatch }) => {
    const { location_id, module_id } = payload;

    return new Promise((resolve, reject) => {
      axios
        .get(`dropdown/view/${location_id}/${module_id}`)
        .then((res) => {
          const { data, err } = res?.data;

          if (err === 0 && data?.length > 0) {
            const dropdownData = {};

            for (const item of data) {
              dropdownData[item.field_name] = item.option;
            }
            resolve(dropdownData);
          } else {
            reject([]);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setSelectedPatient: (state, action) => {
      state.selectedPatient = action.payload;
    },
    setIvfIdList: (state, action) => {
      state.ivfIdList = action.payload;
    },
    setIvfIdListData: (state, action) => {
      state.ivfIdListData = action.payload;
    },
    setIsShowDatabaseBackupModal: (state, action) => {
      state.isShowDatabaseBackupModal = action.payload;
    },
    setModuleWiseDropdownData: (state, action) => {
      state.moduleWiseDropdownData = action.payload;
    },
    setSelectedModuleTab: (state, action) => {
      state.selectedModuleTab = action.payload;
    },
  },
  extraReducers: {
    [getAttendingDrList.pending]: (state) => {
      state.attendingDrList = [];
      state.isDrListLoading = true;
    },
    [getAttendingDrList.rejected]: (state) => {
      state.attendingDrList = [];
      state.isDrListLoading = false;
    },
    [getAttendingDrList.fulfilled]: (state, action) => {
      state.attendingDrList = action.payload;
      state.isDrListLoading = false;
    },
    [getIvfId.pending]: (state) => {
      state.isIvfListLoading = true;
      state.ivfIdList = [];
    },
    [getIvfId.rejected]: (state) => {
      state.isIvfListLoading = false;
      state.ivfIdList = [];
    },
    [getIvfId.fulfilled]: (state, action) => {
      const { ivfIdListData, ivfIdList } = action.payload;
      state.isIvfListLoading = false;
      state.ivfIdListData = ivfIdListData;
      state.ivfIdList = ivfIdList;
    },
    [getMedicineDetailList.pending]: (state) => {
      state.medicineList = [];
      state.isMedicineListLoading = true;
    },
    [getMedicineDetailList.rejected]: (state) => {
      state.medicineList = [];
      state.isMedicineListLoading = false;
    },
    [getMedicineDetailList.fulfilled]: (state, action) => {
      state.medicineList = action.payload;
      state.isMedicineListLoading = false;
    },
    [createDatabaseBackup.pending]: (state) => {
      state.isDatabaseBackupLoading = true;
    },
    [createDatabaseBackup.rejected]: (state) => {
      state.isDatabaseBackupLoading = false;
    },
    [createDatabaseBackup.fulfilled]: (state) => {
      state.isDatabaseBackupLoading = false;
    },
    [getModuleWiseAllDropdownList.pending]: (state) => {
      state.isDatabaseBackupLoading = true;
    },
    [getModuleWiseAllDropdownList.rejected]: (state) => {
      state.isDatabaseBackupLoading = false;
    },
    [getModuleWiseAllDropdownList.fulfilled]: (state, action) => {
      state.isDatabaseBackupLoading = false;
      state.moduleWiseDropdownData = action.payload;
    },
  },
});

export const {
  setSelectedModuleTab,
  setSelectedPatient,
  attendingDrList,
  isDrListLoading,
  ivfIdList,
  setIvfIdList,
  setIvfIdListData,
  setIsShowDatabaseBackupModal,
  setModuleWiseDropdownData,
} = commonSlice.actions;

export default commonSlice.reducer;
